import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import BookSheet from '../components/BookSheet/BookSheet';
import { useApp } from '../context/AppContext';
import { seriesCardsPath } from '../utils/seriesSnapshots';
import './BiblesPage.css';

/**
 * Book Notes at book altitude. One Snapshots room (#696). The leftover
 * Series Notes tab on this page is gone (#676). Character leftover
 * /dossiers URLs still land here. Bare /dossiers is the plot notebook.
 *
 * A series with no selected book must not open this empty room (#782).
 * That path stays in Series Notes. Started books still use Book Notes.
 */
function BiblesPage() {
  const [searchParams] = useSearchParams();
  const { currentProject, currentStory } = useApp();
  if (currentProject?.is_series && !currentStory?.id) {
    return <Navigate to={seriesCardsPath(currentProject.id)} replace />;
  }
  return (
    <div className="bibles-page">
      <BookSheet
        leftoverKind={searchParams.get('kind') || ''}
        leftoverName={searchParams.get('name') || ''}
        leftoverWriteup={searchParams.get('writeup') === '1'}
        focusCategory={searchParams.get('category') || ''}
      />
    </div>
  );
}

export default BiblesPage;
